// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import ContactRepForm from "../containers/ContactRepForm";
import { useTranslation } from 'react-i18next';

export default function ContactRepView() {
    const { t } = useTranslation();
    return (
        <PageContainer title={t("Contact Me")} showShopToolbar={true}>
            <ContactRepForm />
        </PageContainer>
    );
}
